import { IAvailableSeasonTicket } from '@r1-frontend/api-domru/api-season-ticket/v1/season-ticket/dto/ResponseDto';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { ButtonGroup } from '@r1-frontend/ui-react/components/buttons/buttonGroup/ButtonGroup';
import PopupResult, { EResultPopupStatus } from '@r1-frontend/ui-react/components/popups/popupResult';
import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { pluralize } from '@r1-frontend/shared/helpers/pluralize';
import { monthPluralize } from '@r1-frontend/shared/helpers/pluralize/predifined';

import * as ST from './styled';

interface IProps {
    isOpen: boolean,
    onClose: () => void,
    tickets?: IAvailableSeasonTicket[],
}

const HowItWorks = ({
    isOpen,
    onClose,
    tickets,
}: IProps): JSX.Element => (
    <PopupResult
        isOpen={isOpen}
        type={EResultPopupStatus.DEFAULT}
        title={<H3 $withIndent={false}>Как это работает?</H3>}
        onClose={onClose}
    >
        <ST.HowItWorksContent>
            <ST.TicketsInfo>
                <Paragraph4>
                    При покупке абонемента надо пополнить баланс сразу на несколько месяцев вперёд, но плату за услуги мы будем списывать так же раз в месяц.
                </Paragraph4>
                {tickets?.map((ticket) => {
                    const { id, countMonth, delta } = ticket;
                    return (
                        <Paragraph4 key={id}>
                            Абонемент на <ST.BoldText>{countMonth} {pluralize(countMonth, monthPluralize)}</ST.BoldText> — каждый месяц
                            будем списывать на&nbsp;<ST.BoldText>{delta} ₽ меньше</ST.BoldText>.
                        </Paragraph4>
                    );
                })}
            </ST.TicketsInfo>
            <ButtonGroup>
                <Button bType={'secondary'} onClick={onClose}>Понятно</Button>
            </ButtonGroup>
        </ST.HowItWorksContent>
    </PopupResult>
);

export default HowItWorks;
